module.exports = __webpack_public_path__ + "static/img/search_no_data.73f8524.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/ordering/search_no_data.png
// module id = ZIWo
// module chunks = 4